import React, { Component, Fragment } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { CREATE_EDIT_PHYSICAL_FORM_NAME } from 'Common/FormEnum';
import { CreateEditPhysicalEnum } from 'Common/FieldEnum';

import PreviewPhysicalComponent from '../../components/createEditPhysical/PreviewPhysical';

class PreviewPhysicalContainer extends Component {
  render() {
    return (
      <Fragment>
        <PreviewPhysicalComponent {...this.props} />
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_PHYSICAL_FORM_NAME);
const mapStateToProps = state => {
  return {
    physicalItemsInfo: selector(state, [
      CreateEditPhysicalEnum.PhysicalItemsInfo,
    ]),
  };
};

PreviewPhysicalContainer = reduxForm({
  form: CREATE_EDIT_PHYSICAL_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PreviewPhysicalContainer);

export const PreviewPhysical = connect(
  mapStateToProps,
  null
)(PreviewPhysicalContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/containers/createEditPhysical/PreviewPhysical.js